import React from "react";
import ScopeSummaryBox from "../../../../planning/dailyDispatch/workScopeSummary/ScopeSummaryBox";

/**
 * Wraps a ScopeSummaryBox for T&M work-detail selection.
 *
 * @param {Object} props Component props.
 * @param {Object} props.scope Dispatch scope.
 * @param {Object} props.job Job for the scope card.
 * @param {boolean} [props.isSelected=false] Highlight ring when selected.
 * @param {Function} [props.onClick] Card click handler.
 * @param {boolean} [props.readOnly=false] Disables pointer cursor / click.
 * @returns {JSX.Element}
 */
const ScopeCardWrapper = ({
  scope,
  job,
  isSelected = false,
  onClick,
  readOnly = false,
}) => {
  return (
    <div
      className={`max-w-[380px] ${
        isSelected ? "ring-2 ring-blue-500 rounded" : ""
      } ${!readOnly ? "cursor-pointer" : ""}`}
      onClick={!readOnly ? onClick : undefined}
    >
      <ScopeSummaryBox
        scope={scope}
        job={job}
        display="report"
      />
    </div>
  );
};

export default ScopeCardWrapper;
